const pageTitle = {
  install(Vue, options) {
    Vue.prototype.$setPageTitle = (title) => {
      // Set the current page title
      let staticTitle = 'wfv'
      if(title) {
        return staticTitle + ' - ' + title;
      } else {
        return title;
      }
    }
  }
};

// Usage example:
// {{ $setPageTitle(article.title) }}
export default pageTitle;



// WEBPACK FOOTER //
// ./src/plugins/pagetitle.js